/* eslint-disable */
import ko from 'knockout';
var urlTestTool = function () {
  this.showTesting = ko.observable();
  this.resultType = ko.observable();
  this.resultString = ko.observable();
};
export default urlTestTool;

